"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHADE_INFO = void 0;
const SHADE_INFO = exports.SHADE_INFO = 'shade-info';
